module.exports = __webpack_public_path__ + "static/media/buy_finish_service_rent_3.0a029dae.jpg";